import React, { useRef, useEffect, useCallback } from "react";

/**
 * Pointer-driven 3D tilt for cards. Real perspective + rotateX/Y, capped at
 * `max` degrees (default 6°). Disabled on touch devices and when the user
 * prefers reduced motion — the card just sits flat.
 */
export default function TiltCard({ children, className = "", max = 6 }) {
  const ref = useRef(null);
  const enabled = useRef(false);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const noHover = window.matchMedia("(hover: none)").matches;
    enabled.current = !reduced && !noHover;
  }, []);

  const onMove = useCallback((e) => {
    const el = ref.current;
    if (!enabled.current || !el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `perspective(900px) rotateY(${px * max}deg) rotateX(${-py * max}deg)`;
  }, [max]);

  const onLeave = useCallback(() => {
    if (ref.current) ref.current.style.transform = "perspective(900px) rotateY(0deg) rotateX(0deg)";
  }, []);

  return (
    <div
      ref={ref}
      className={className}
      style={{ transition: "transform 0.4s cubic-bezier(0.2,0.8,0.2,1)", transformStyle: "preserve-3d", willChange: "transform" }}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
    >
      {children}
    </div>
  );
}
